export class Utils {
    public static async cleanObjects(object: any): Promise<any> {
        for (const key in object) {
            const input = key;
            for (const field in object[input]) {
                if (field === 'type') {
                    switch (object[input][field]) {
                        case 'text':
                        case 'password':
                        case 'textarea':
                            object[input].value = '';
                            break;
                        case 'checkbox':
                            object[input].value = false;
                            break;
                        case 'select':
                            object[input].value = null;
                            object[input].options = [];
                            break;
                        case 'selectmenu':
                        case 'selectmultiple':
                            object[input].value = [];
                            object[input].options = [];
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return object;
    }

    public static blobIE(res: any, mediaType: string, extension: string): Blob {
        let blob: Blob;
        try {
            if (res._body) {
                blob = new Blob([res._body], { type: mediaType });
            } else {
                blob = new Blob([res], { type: mediaType });
            }
        }
        catch (e) {
            try {
                const ew = window.Blob;
                if (ew) {
                    const bb = new MSBlobBuilder();
                    if (res._body) {
                        bb.append(res._body);
                    } else {
                        bb.append(res);
                    }
                    blob = bb.getBlob("application/" + extension);
                }
            }
            catch (e2) {
            }
        }
        return blob;
    }

    public static processLogin(originalData: any, sessionExpiration: number): any {
        const now = Date.now();
        const TWO_HOURS_MS = 7200000;

        let expiryMs: number;
        if (sessionExpiration > 0) {
            expiryMs = now + Math.min(sessionExpiration, TWO_HOURS_MS);
        } else {
            const serverExpires = originalData['.expires'];
            const serverExpiryMs = serverExpires ? new Date(serverExpires).getTime() : NaN;
            expiryMs = !isNaN(serverExpiryMs) ? serverExpiryMs : now + TWO_HOURS_MS;
        }
        const date = new Date(expiryMs);
        const data = {
            id: originalData.idUser,
            expires: date.toUTCString(),
            username: originalData.guidUser,
            access_token: originalData.access_token,
            refresh_token: originalData.refresh_token,
            name: originalData.name,
            companyName: originalData.companyName,
            companyId: Number(originalData.companyId),
            tokenIvSign: originalData.tokenIvSign,
            idPerfil: Number(originalData.idPerfilUser),
            areas: JSON.parse(originalData['rol']),
        };

        return data;
    }

    public static clone(object: any): any {
        return JSON.parse(JSON.stringify(object));
    }

    public static isDesktop(): boolean {
        return window.innerWidth > 1024;
    }

    public static isMobile(): boolean {
        return window.innerWidth < 992;
    }

    public static parseEnum(enumList: { [key: string]: string | number }) {
        const values = [];
        for (const n in enumList) {
            if (typeof enumList[n] === 'number') {
                values.push({ value: enumList[n], key: n });
            }
        }

        return values;
    }

}
